import env from 'enviro';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useQuery } from 'data-fetching-client';
import { GET_USER_INFO } from 'pricing-pages-api/user/queries';
import { MarketingHubPage } from './marketing/MarketingHubPage';

// NOTE: DO NOT USE THIS COMPONENT FOR PRODUCTION CODE
// This is a temporary component to enable development of the new pricing page
import { jsx as _jsx } from "react/jsx-runtime";
export const PricingPageRoutes = () => {
  var _userInfoQuery$data;
  const userInfoQuery = useQuery(GET_USER_INFO);
  const match = useRouteMatch();
  const isInternalHubspotUser = ((_userInfoQuery$data = userInfoQuery.data) === null || _userInfoQuery$data === void 0 ? void 0 : _userInfoQuery$data.userInfo.user.email.endsWith('@hubspot.com')) || false;
  if (env.isProd() || !isInternalHubspotUser) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: "/marketing"
    });
  }
  return /*#__PURE__*/_jsx(Switch, {
    children: /*#__PURE__*/_jsx(Route, {
      path: `${match.path}/marketing`,
      component: MarketingHubPage
    })
  });
};